import React, {useContext} from 'react';
import GeneralInformation from "./GeneralInformation";
import IranInsurance from "./IranInsurance";
import InternalResource from "./InternalResource";
import FinancialInformation from "./FinancialInformation";
import FurtherInformation from "./FurtherInformation";
import {InsuranceContext} from "../InsuranceContext";
import "../style.scss"
import _axios from "../../../httpService";
import {prefixUrl} from "../../../utils/utilsData";
import {toast} from "react-toastify";
import {initialFormObject} from "../formObject";
import {validateInsuranceForm} from "../functions";

function MainForm(props) {
  const helper = useContext(InsuranceContext);
  const setMyData = helper.setMyData
  const myData = helper.myData

  const submitFormHandler = async () => {
    const sendData = myData.sendData
    if (!validateInsuranceForm(sendData)) {
      return
    }


    const ob = {
      request: "insuranceSubmit", data: sendData
    }
    const res = await _axios.post(prefixUrl() + "/insurance/", ob)

    if (res?.data?.status) {
      toast?.success(res?.data?.message)
      const tSendData = initialFormObject.sendData;
      debugger
      if(myData.sendData.mode==='edit')

      setMyData({sendData:{//

          mode: "add",//
          id: "",//
          overallInfo: {
            'insuranceNumber': "", //
            'contractType': "", //
            'customerId': "", //
            'organizationId': "", //
            'contractId': "", //
            'insuranceTypeId': "", //
            'insurancePrice': "", //
            'paymentType': "", //
            'plate': "", //

            ////
            //  ما اینجا یه وابستگی داریم اگه نوع قرار داد سازمانی بود
            // باید دو تا آرلوکاپ دیده بشن آرلوکاپ مشتری و آرلوکاپ  قرار داد
            //و آرلوکاپ قرار داد یه وابستگی به نتیجه ی جواب آرلوکاپ انتخاب سازمان داره
            // که اینجا دارم اون وابستگی رو توی کلید  ذخیره میکنم

            depContractRLookup: "",//
            // در صورتی که نتیجه ی آرلوکاپ مشتری  اطلاعات سازمانب اومد باید آرلوکاپ قرار داد ظاهر بشه. و اینجا مشخصش میکنم
            showContractRLookUp: false,

          },


          iranInsurance: {
            'firstInstallmentDate': "", //
            'depositBankId': "", //


          }, internalResources: {
            'firstInternalDate': "", //
            'dayCount': "", //
            'internalInstallmentCount': "", //

          },


          financial: {
            'hasAgent': "", //
            'agentId': "", //
            'prePayment': "", //
            'receiveType': "", //
            'fundId': "", //
            'bankId': "", //
            'addedValue': "", //
          },


          furtherInfo: {
            'description': "",//
          }, //

        }})
    } else {
      toast.error(res?.data?.message)
    }


  }
  const paymentHandler = () => {

  }

  const paymentType = myData?.sendData?.overallInfo?.paymentType

  ///   بر اساس اینکه نوع پرداخت چیه باید یه سری از این بخش ها پیدا یا پنهان باشند
  const showIranInsurance = (paymentType === "اقساط بیمه ایران" || paymentType === "اقساط بیمه ایران و منابع داخلی")
  const showInternalResource = (paymentType === "اقساط منابع داخلی" || paymentType === "اقساط بیمه ایران و منابع داخلی")

  return (<div className={'insurance__style'}>
    <GeneralInformation/>
    {showIranInsurance && <IranInsurance/>}
    {showInternalResource && <InternalResource/>}
    <FinancialInformation/>
    <FurtherInformation/>


    <div className={'d-flex flex-wrap justify-content-center  mt-2'}>

      <button onClick={submitFormHandler} className={'mx-1 btnCustom btnSubmit w__200px'}>ثبت</button>
      {/*<button onClick={paymentHandler} className={'mx-1 btnCustom bg__white border-e-blue-950  w__200px'}>پرداخت قسط*/}
      {/*</button>*/}


    </div>

  </div>);
}

export default MainForm;